import { StoreVariableWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('StoreVariable')
export class StoreVariableConnectorProvider extends ConnectorProvider<StoreVariableWorkflowNode> {}
